import * as React from 'react';
import { Col } from 'reactstrap';
import './loader.css';

interface IAlertCardLoaderProps {
}

export const AlertCardLoader: React.SFC<IAlertCardLoaderProps> = (props) => {
  return (
    <Col className="col-12">
      <div className="animated-background border info-card white-background alert-card geo-search-card cardloader" style={{ padding: 0 }}>
        <svg width="100%" height="100%" id="CardLoader">
          <defs>
            <mask id="loadercardmask">
              <rect width="100%" height="100%" fill="white" />
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="412px" height="166px" viewBox="0 0 4120 1660" preserveAspectRatio="xMidYMid meet">
                <g id="layer101" fill="#2abcca" stroke="none">
                  <path d="M0 830 l0 -830 2060 0 2060 0 0 830 0 830 -2060 0 -2060 0 0 -830z" />
                </g>
                <g id="layer102" fill="#cfcfcf" stroke="none">
                  <path d="M0 830 l0 -830 2060 0 2060 0 0 830 0 830 -2060 0 -2060 0 0 -830z m3915 505 l0 -160 -595 0 -595 0 -3 150 c-1 82 0 155 2 162 4 11 119 13 598 11 l593 -3 0 -160z m-3205 -490 l0 -65 -190 0 -190 0 0 65 0 65 190 0 190 0 0 -65z m1690 -60 l0 -65 -265 0 -265 0 0 65 0 65 265 0 265 0 0 -65z m860 0 l0 -65 -420 0 -420 0 0 65 0 65 420 0 420 0 0 -65z m-2470 -180 l0 -65 -230 0 -230 0 0 65 0 65 230 0 230 0 0 -65z m1190 -90 l0 -65 -60 0 -60 0 0 65 0 65 60 0 60 0 0 -65z m470 0 l0 -65 -185 0 -185 0 0 65 0 65 185 0 185 0 0 -65z m-1440 -250 l0 -115 -395 0 -395 0 0 115 0 115 395 0 395 0 0 -115z m970 -40 l0 -65 -65 0 -65 0 0 65 0 65 65 0 65 0 0 -65z m930 -10 l0 -65 -420 0 -420 0 0 65 0 65 420 0 420 0 0 -65z" />
                </g>
                <g id="layer103" fill="#ffffff" stroke="none">
                  <path d="M5 1648 c-3 -7 -4 -380 -3 -828 l3 -815 2058 -3 2057 -2 0 830 0 830 -2055 0 c-1635 0 -2057 -3 -2060 -12z m3910 -313 l0 -160 -595 0 -595 0 -3 150 c-1 82 0 155 2 162 4 11 119 13 598 11 l593 -3 0 -160z m-3205 -490 l0 -65 -190 0 -190 0 0 65 0 65 190 0 190 0 0 -65z m1690 -60 l0 -65 -265 0 -265 0 0 65 0 65 265 0 265 0 0 -65z m860 0 l0 -65 -420 0 -420 0 0 65 0 65 420 0 420 0 0 -65z m-2470 -180 l0 -65 -230 0 -230 0 0 65 0 65 230 0 230 0 0 -65z m1190 -90 l0 -65 -60 0 -60 0 0 65 0 65 60 0 60 0 0 -65z m470 0 l0 -65 -185 0 -185 0 0 65 0 65 185 0 185 0 0 -65z m-1440 -250 l0 -115 -395 0 -395 0 0 115 0 115 395 0 395 0 0 -115z m970 -40 l0 -65 -65 0 -65 0 0 65 0 65 65 0 65 0 0 -65z m930 -10 l0 -65 -420 0 -420 0 0 65 0 65 420 0 420 0 0 -65z" />
                </g>
              </svg>
            </mask>
          </defs>

          <rect id="back" width="100%" height="100%" fill="white" mask="url(#loadercardmask)" />
        </svg>
      </div>
    </Col>
  )
};



// WEBPACK FOOTER //
// ./src/share/components/ChartLoader/AlertCardLoader.tsx